import { Vue, Component, Prop } from 'vue-property-decorator';
import { TableCellData } from 'components';

@Component
export default class PropsTableCellHeader extends Vue {
	@Prop({
		default() {
			return {
				cell: {
					text: ''
				}
			};
		}
	})
	data!: TableCellData;
}
